// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__KLK1e","content":"LayoutSettings_content__fSN7y"};